import { AwsRum, AwsRumConfig, PageIdFormat } from 'aws-rum-web'
import { initializeAwsRum } from '@/utils/awsRumErrorCapture'

try {
  const config: AwsRumConfig = {
    sessionSampleRate: Number(process.env.AWS_RUM_SESSION_SAMPLE_RATE!),
    guestRoleArn: process.env.AWS_RUM_QUEST_ROLE_ARN!,
    identityPoolId: process.env.AWS_RUM_IDENTITY_POOL_ID,
    endpoint: process.env.AWS_RUM_ENDPOINT,
    pageIdFormat: process.env.AWS_RUM_PAGE_ID_FORMAT as PageIdFormat,
    sessionEventLimit: Number(process.env.AWS_RUM_SESSION_EVENT_LIMIT),
    telemetries: [
      ['performance', { eventLimit: Number(process.env.AWS_RUM_TELEMETRIES_PERFORMANCE_EVENT_LIMIT) }],
      ['errors', { stackTraceLength: Number(process.env.AWS_RUM_TELEMETRIES_ERRORS_STACK_TRACE_LENGTH) }],
      [
        'http',
        {
          urlsToInclude: [new RegExp(process.env.AWS_RUM_TELEMETRIES_HTTP_URLS_TO_INCLUDE!)],
          urlsToExclude: [new RegExp(process.env.AWS_RUM_TELEMETRIES_HTTP_URLS_TO_EXCLUDE!)],
          stackTraceLength: Number(process.env.AWS_RUM_TELEMETRIES_HTTP_HTTP_STACK_TRACE_LENGTH),
          addXRayTraceIdHeader: JSON.parse(process.env.AWS_RUM_TELEMETRIES_HTTP_ADD_XRAY_TRACE_ID_HEADER!),
        },
      ],
    ],
    allowCookies: JSON.parse(process.env.AWS_RUM_ALLOW_COOKIES!),
    enableXRay: JSON.parse(process.env.AWS_RUM_ENABLE_XRAY!),
  }

  if (
    process.env.NODE_BUILD_ENV === 'dev' ||
    process.env.NODE_BUILD_ENV === 'dev2' ||
    process.env.NODE_BUILD_ENV === 'dev3' ||
    process.env.NODE_BUILD_ENV === 'stg' ||
    process.env.NODE_BUILD_ENV === 'stg1' ||
    process.env.NODE_BUILD_ENV === 'stg2' ||
    process.env.NODE_BUILD_ENV === 'production' ||
    process.env.NODE_BUILD_ENV === 'prd'
  ) {
    // eslint-disable-next-line
    const awsRum: AwsRum = new AwsRum(
      process.env.AWS_RUM_APPLICATION_ID!,
      process.env.AWS_RUM_APPLICATION_VERSION!,
      process.env.AWS_RUM_APPLICATION_REGION!,
      config
    )
    initializeAwsRum(awsRum)
  }
} catch (error) {
  // Ignore errors thrown during CloudWatch RUM web client initialization
  // eslint-disable-next-line
  console.log(error)
}
